/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const pluginPostbackDelPaymentOrderRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	order_id: z.uuid(),
	payment_id: z.uuid(),
});
